import axiosInstance from "@/composables/axios-instance";

const state = {
    spaces: []
};

const getters = {
    getSpaces(state){
        return state.spaces;
    }
};

const mutations = {
    setSpacesList(state, list){
        state.spaces = list;
    }
};

const actions = {
    getSpacesList({ commit }, id) {
        return axiosInstance.get("/space/get/", {params:{
            id
        }}).then(response => {
            commit("setSpacesList", response.data);
        }).catch(error => {
            console.error(error);
        })
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};